import { Component, JSX } from "solid-js";

export type BadgeVariant =
  | "default"
  | "todo"
  | "inProgress"
  | "inReview"
  | "done"
  | "cancelled"
  | "critical"
  | "high"
  | "medium"
  | "low"
  | "none"
  | "epic"
  | "story"
  | "task"
  | "bug"
  | "readOnly"
  | "archived";

export interface BadgeProps {
  variant?: BadgeVariant;
  class?: string;
  children: JSX.Element;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: "bg-sunken text-ink-2 border-line",
  todo: "bg-sunken text-ink-2 border-line",
  inProgress: "bg-signal-blue-tint text-signal-blue border-signal-blue/25",
  inReview: "bg-signal-amber-tint text-signal-amber border-signal-amber/25",
  done: "bg-signal-green-tint text-signal-green border-signal-green/25",
  cancelled: "bg-signal-red-tint text-signal-red border-signal-red/25",
  critical: "bg-signal-red-tint text-signal-red border-signal-red/25",
  high: "bg-signal-amber-tint text-signal-amber border-signal-amber/25",
  medium: "bg-sunken text-ink-2 border-line",
  low: "bg-sunken text-ink-2 border-line",
  none: "bg-sunken text-ink-3 border-line",
  epic: "bg-signal-cyan-tint text-signal-cyan border-signal-cyan/25",
  story: "bg-signal-green-tint text-signal-green border-signal-green/25",
  task: "bg-signal-blue-tint text-signal-blue border-signal-blue/25",
  bug: "bg-signal-red-tint text-signal-red border-signal-red/25",
  readOnly: "bg-signal-amber-tint text-signal-amber border-signal-amber/25",
  archived: "bg-sunken text-ink-3 border-line",
};

export const Badge: Component<BadgeProps> = (props) => {
  const variantClass = variantClasses[props.variant ?? "default"];
  return (
    <span
      class={
        "inline-flex items-center gap-1 h-6 px-1.5 text-xs font-medium rounded-sm border " +
        variantClass +
        " " +
        (props.class ?? "")
      }
    >
      <span
        aria-hidden="true"
        class="w-1.5 h-1.5 rounded-full bg-current shrink-0"
      />
      {props.children}
    </span>
  );
};
